// Outcome-coloured card styling shared by the rail cards and the drill-set cards.
// A conversation card carries a left-accent colour at rest and, on hover, tints its
// background and border to the same family for emphasis:
//   abandoned                → red
//   reservation the agent assisted → green (emerald)
//   everything else          → brand blue
//
// The `!` on the left-border colour is required: the card's all-sides `border-…`
// shorthand otherwise wins the left edge and greys the accent out.

const ACCENT = {
  abandoned: "!border-l-red-500",
  reservation_assisted: "!border-l-emerald-500",
};

const HOVER = {
  abandoned:
    "hover:bg-red-50 dark:hover:bg-red-900/20 hover:border-red-300 dark:hover:border-red-800 hover:!border-l-red-400",
  reservation_assisted:
    "hover:bg-emerald-50 dark:hover:bg-emerald-900/20 hover:border-emerald-300 dark:hover:border-emerald-800 hover:!border-l-emerald-400",
};

/** Resting left-accent colour class for a conversation's outcome. */
export const outcomeAccentClass = (outcome) => ACCENT[outcome] || "!border-l-[#32B1FF]";

/** Hover treatment (bg tint + border + brighter left accent) for an outcome. */
export const outcomeHoverClass = (outcome) =>
  HOVER[outcome] ||
  "hover:bg-[#32B1FF]/5 dark:hover:bg-[#32B1FF]/10 hover:border-[#32B1FF]/40 hover:!border-l-[#7FD0FF]";
